import React from 'react'
import { Box,Typography,Button} from '@mui/material'
import HeroBannerImage from '../assets/images/banner.jpg'

const HeroBanner = () => {
  return (
    <Box sx={{
        mt:{lg:'100px',xs:'70px'},
        ml:{sm:'50px'}
    }} position={"relative"} p={"20px"}
        
    >

        <Typography color={"#FF2625"} fontWeight={"600"} fontSize={"40px"} mb={3}>
           TRANSFOR-M-E Club
        </Typography>

        <Typography fontWeight={"700"} sx={{fontSize:{lg:'50px',xs:'40px'}}} mb={"23px"} mt={"30px"} >
            Don't Sit. <br/> Get Fit.
        </Typography>

        <Typography fontSize={"24px"} lineHeight={"35px"} mb={4}>
            Click the button to get effective exercises to make you strong.
        </Typography>

        <Button variant='contained'
        color='error'
        href='#exercises'
        sx={{backgroundColor:'#FF26625'}}
        padding='10px'
        >
            Check Exercises
        </Button>
        <Typography fontWeight={600}
        color={"#FF2625"}
        sx={{opacity:0.3, display:{lg:'block', xs:'none'}}}
        fontSize={"100px"}
        >
            Beast Mode <br/> On
        </Typography>

            <img src={HeroBannerImage} alt='banner' className='hero-banner-img'/>

    </Box>
  )
}

export default HeroBanner